import { IAddOn, IGlassesPackage } from '../types';
import { getQSVar, getTotalAddOnsPrice } from '../utils';

interface IPricingDetails {
    framePrice: number;
    glassesPrice: number;
    discount: number;
    subTotal: number;
    total: number;
}

export function getPricingDetails(
    selectedPackage: IGlassesPackage,
    addOns: IAddOn[] | undefined
): IPricingDetails | undefined {
    const framePrice = Number(getQSVar('price')) || 0;
    const addOnsPrice = addOns ? getTotalAddOnsPrice(addOns) : 0;
    const glassesPrice = selectedPackage.priceInt;

    // No discount right now, can be changed based on action
    const discount = 0;

    const subTotal = framePrice + glassesPrice + addOnsPrice;
    const total = subTotal - discount;

    return {
        framePrice,
        glassesPrice,
        discount,
        subTotal,
        total,
    };
}
